export default "__VITE_PUBLIC_ASSET__bbd89ed5__"